import { RouteProps } from '../../routes/AppRouter'
import { Title } from '../../components/common/Title'
import { TITLE_IMMUNOCOM} from '../../routes/title-constants'
import { useTranslation } from 'react-i18next'
import { ImmunocomTable } from '../../features/immunocom'

export const Table = (props: RouteProps) => {
  const { t } = useTranslation()

  return (
    <>
      <Title title={t(TITLE_IMMUNOCOM)} color={props.color} />
      <ImmunocomTable />
    </>
  )
}
